import { InteractionStatuses, MessageStatuses } from './message.model';

export class MessagesSearchModel {
  status?: MessageStatuses;
  interactionStatus?: InteractionStatuses;
  searchText: string;

  objectKeyField: string;
  objectKeyValue: string;
  objectRelationship?: string;
}
